import React from 'react';
import { FormattedMessage } from 'react-intl';

/**
 * @description 패키지의 심사 여부를 보여주는 컴포넌트. props.status 값에 따라 다르게 보여줌.
 */
const PkgStatus = props => {

    const statusValue = decideStatusValue(props.status, props.isMyPkg)

    const lightStyle = {
        width: 8,
        height: 8,
        borderRadius: 4,
        backgroundColor : statusValue.color,
        border : props.status === 'creating' ? 'none' : props.status === 'editing' ? 'solid 1px #ff6060' : 'none',
        marginRight: 5
    }

    return (
        <div 
            style={{
                display: 'flex',
                justifyContent: props.style ? props.style.justifyContent : 'flex-start',
                alignItems: 'center'
            }}
        >
            <div style={lightStyle}/>
            <FormattedMessage
                id={statusValue.id}
                defaultMessage={statusValue.defaultMessage}
            />
        </div>
    );
};

/**
 * @description 패키지의 배포 상태에 따라 컬러및 텍스트 id와 default message를 object로 반환하는 함수
 * @param {String} status 현재 패키지 상태
 * @returns {Object} {color : 컬러 hex code, id : 상태 텍스트의 intl id, defaultMessage : 텍스트 id 못받아올 떄 보여줄 default text}
 */
export const decideStatusValue = (status, isMyPkg) =>{
    let value = {
        color : '#dddddd',
        id : 'PkgStatus.creating',
        defaultMessage : '작성중'
    };

    switch(status){
        case 'creating' :
            value = {
                color : '#FF9900',
                id : 'PkgStatus.creating',
                defaultMessage : '작성 중'
            };
            break;
        case 'under review' :
            value = {
                color : '#fff000',
                id : 'PkgStatus.underReview',
                defaultMessage : '심사 중'
            };
            break;
        case 'approved' : 
            value = {
                color : '#5fffaf',
                id : isMyPkg ? 'PkgStatus.approved.mypackage': 'PkgStatus.approved',
                defaultMessage : isMyPkg? 
                'Approved': 'Approved'
            };
            break;
        case 'pre deleted' : 
        case 'unapproved' :
                value = {
                    color : '#ff6060',
                    id : 'PkgStatus.unapproved',
                    defaultMessage : '미승인'
                };
                break;
        case 'editing' :
            value = {
                color : 'rgba(255,255,255,0)',
                id : 'PkgStatus.editing',
                defaultMessage : '수정 중'
            };
            break;
        case 'discontinue' :
            value = {
                color : '#dddddd',
                id : 'PkgStatus.discontinue',
                defaultMessage : '배포 중단'
            };
            break;
        default :
            value = {
                color : '#ffffff',
                id : 'PkgStatus.creating',
                defaultMessage : '작성중'
            };

    }
    return value;
}

export default PkgStatus;